import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  queryPriceData,
  getQueryKey as getPriceDataQueryKey,
  getDefault,
} from '../queryPriceData';
import {
  queryPriceTargets,
  getQueryKey as getPriceTargetsQueryKey,
  getDefaultResponse,
} from '../queryPriceTargets';
import { useValuationData } from '@/pages/CompanyReport/components/Valuation';

export default function useAnalystPriceTargets() {
  const valuationData = useValuationData();
  const {
    data: priceTarget = getDefaultResponse(),
    status: priceTargetStatus,
  } = useQuery({
    queryKey: getPriceTargetsQueryKey(valuationData.canonicalUrl ?? ''),
    queryFn: queryPriceTargets,
    enabled: Boolean(valuationData.canonicalUrl),
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    placeholderData: keepPreviousData,
  });
  const { data: priceData = getDefault(), status: priceDataStatus } = useQuery({
    queryKey: getPriceDataQueryKey(valuationData.canonicalUrl ?? ''),
    queryFn: queryPriceData,
    enabled: Boolean(valuationData.canonicalUrl),
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    placeholderData: keepPreviousData,
  });
  return {
    priceTarget,
    priceData,
    priceTargetStatus,
    priceDataStatus,
  };
}
